export const bannerModalGenerateLinkTranslationKeys = {
  afftrackTypeHere: 'afftrack.type-here',

  promoModalButtonAcceptRules: 'offers.page-offer-tab-activation-accordion-accept-rules-title',
  promoModalButtonActivateOffer: 'promo.modal-button-activate-offer',
  promoModalButtonCopyLink: 'promo.modal-button-copy-link',
}
